import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface AssetTagProps {
    children: ReactNode
    tone?: 'light' | 'dark'
    className?: string
}

// Small mono label styled like the asset tag on a rented device. Use it sparingly as a section marker.
export const AssetTag: FC<AssetTagProps> = ({ children, tone = 'light', className }): ReactNode => {
    return (
        <span
            className={cn(
                'inline-flex items-center gap-2 rounded-md border py-1 pr-2.5 pl-1.5 font-mono text-xs tracking-[0.14em] uppercase',
                tone === 'light' ? 'border-foreground/15 bg-card/80 text-foreground' : 'border-ink-foreground/20 bg-ink-raised text-ink-foreground',
                className
            )}
        >
            <span
                aria-hidden='true'
                className={cn('size-2.5 rounded-full border-2', tone === 'light' ? 'border-foreground/35 bg-background' : 'border-ink-foreground/40 bg-ink')}
            />

            {children}
        </span>
    )
}
